export const messages = {
  allRequiredFields: 'Please fill in all required fields',
  validEmail: 'Please use a valid email address',
  passwordLength: 'Passwords must be at least 7 characters',
  tempPasswordLength: 'New user passwords must be at least 4 characters',
  registrationInProgress: 'Registering...',
  duplicateEmail: 'This email has already been used',
  passwordMatch: 'Passwords must match',
  nameAndEmail: 'Name and email cannot be left blank',
};
